import { useState, useCallback } from 'react'
import {
  requestCustomersList,
} from 'requests/customers'

const DEFAULT_ERROR = { error: false, response: {} }

export default function useSearchCustomers() {
  const [customers, setCustomers] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(DEFAULT_ERROR)
  const [pagination, setPagination] = useState()
  const [currentPage, setCurrentPage] = useState(0)

  const searchCustomers = useCallback(async ({ page, filters }) => {
    setLoading(true)
    setError(DEFAULT_ERROR)
    setCurrentPage(page)

    const response = await requestCustomersList(page, filters)

    if (response.error) {
      return setError({ error: true, response })
    }

    setCustomers(response.data)
    setPagination(response.meta?.pagination)
    return setLoading(false)
  }, [])

  const search = {
    customers,
    error,
    loading,
    pagination,
    currentPage,
  }

  return [search, searchCustomers]
}
